import { Component } from '@angular/core';
import { CustomSwitchComponent } from '../../../shared-components/custom-switch/custom-switch.component';
import { TranslateService } from '../../../services/translate/translate.service';

@Component({
	selector: 'app-switches',
	templateUrl: './switches.component.html',
	styleUrls: ['./switches.component.scss'],
	standalone: false,
})
export class SwitchesComponent {
	primaryValue: string = '';
	successValue: string = '';
	infoValue: string = '';
	warningValue: string = '';
	dangerValue: string = '';
	disabledValue: string = '';
	ngModelValue = false;
	projectedContentValue = false;
	validationValid = false;
	requiredSwitchRules: any[] = [];

	constructor(private translateService: TranslateService) {
		this.requiredSwitchRules = [CustomSwitchComponent.createRules(this.translateService).required('You must accept the terms')];
	}

	onSwitchChange(switchName: string, checked: boolean): void {
		if (switchName === 'Primary') {
			this.primaryValue = checked ? 'Enabled' : 'Disabled';
		} else if (switchName === 'Success') {
			this.successValue = checked ? 'Active' : 'Inactive';
		} else if (switchName === 'Info') {
			this.infoValue = checked ? 'On' : 'Off';
		} else if (switchName === 'Warning') {
			this.warningValue = checked ? 'Proceed' : 'Cancel';
		} else if (switchName === 'Danger') {
			this.dangerValue = checked ? 'Delete' : 'Keep';
		} else if (switchName === 'Disabled') {
			this.disabledValue = checked ? 'Active' : 'Inactive';
		} else if (switchName === 'NgModel') {
			this.ngModelValue = checked;
		} else if (switchName === 'Projected') {
			this.projectedContentValue = checked;
		}
	}

	onValidationChange(validation: { isValid: boolean; errors: string[] }): void {
		this.validationValid = validation.isValid;
	}
}
